export default {
    CouponApply: {
        route_header_title: 'Kupon Ekle',
        content_header_description:
            'Kupon kodunu aşağı girerek puan kazanabilirsin',
        coupon_add_button: 'Kupon Ekle',
        coupon_toast_message:
            '{{amount}} puan değerindeki kupon başarıyla tanımlandı',
        coupon_input_placeholder: 'Kupon Kodu Giriniz',
    },
    AccountActivitySectionList: {
        empty_sheet_title: 'Hesap Haraketi Yok',
        empty_sheet_description: 'Herhangi bir hesap hareketi bulunamadı',
    },
    WalletDetail: {
        packages_section_title: 'Abonelik/Paket Satın Al',
        packages_badge_label_all: 'Tümünü Gör',
        purchased_packages_section_title: 'Abonelikler/Paketler',
        purchased_packages_section_description:
            'Abonelik ve paketlerini takip et bütçene katkı sağla',
        purchased_packages_badge_label_all: 'Tümünü Gör',
        purchased_packages_section_detail_button_label: 'Detay',
        header_title: 'BAKİYE',
        header_point: 'Puan: {{point}}',
        help: 'Yardım',
        help_description: 'Bir sorun mu var?',
        read_qr: 'QR Öde',
        menu_earnings_title: 'Kazançlarım',
        menu_earnings_subtitle: "Macellan SuperApp'in bütçene katkısı",
        menu_brand_title: 'Marka Hakkında',
        menu_brand_subtitle: 'Menü, kampanyalar, şubeler ve daha fazlası',
        wallet_history_title: 'Cüzdan Hareketleri',
        wallet_history_subtitle: 'Gerçekleştirilen son 5 işlem',
        wallet_history_all: 'Tüm Hareketler',
        agreement_updated:
            '{{wallet}} cüzdanına ait sözleşme koşulları güncellenmiştir',
        passive_status_toast_message: '{{wallet}} cüzdanı pasife alınmıştır',
        wallet_benefits_title: 'Cüzdan avantajları nelerdir?',
        orders_title: 'Siparişler',
        orders_subtitle: 'Son verdiğin siparişlerini görüntüle',
        orders_badge_label_all: 'Tüm Siparişler',
        feature_title: 'Özellikler',
        settings_title: 'Ayarlar',
        announcement_title: 'Duyurular',
    },
    WalletModules: {
        route_header_title: 'Tüm İşlemler',
        payment: 'QR Göster',
        deposit: 'Bakiye Yükle',
        deposit_instruction: 'Yükleme Talimatı',
        coupon: 'Kupon Ekle',
        wallet_share: 'Cüzdan Paylaş',
        gift_card: 'Hediye Kartı',
        ticket_system: 'Biletlerim',
        branches: 'Şubeler',
        history: 'Hesap Hareketleri',
        help: 'Yardım',
        agreement: 'Cüzdan Sözleşmesi',
        wallet_visibility: 'Cüzdan Görünürlüğü',
        products: 'Ürünler',
        invoices: 'Faturalar',
        card_definition: 'Kart Ekle',
        entry_control: 'Geçiş İşlemlerim',
    },
    EntryControlEvents: {
        content_header_title: 'Geçiş İşlemlerim',
        content_header_description:
            'Tüm geçiş işlemlerini buradan görüntüleyebilirsin',
        empty_sheet_title: 'İşlem Bulunamadı',
        empty_sheet_description: 'Herhangi bir geçiş işlemin bulunmuyor',
        status_undefined: 'Tanımsız',
        status_approved: 'Onaylandı',
        status_denied: 'Reddedildi',
    },
    EntryControlEventDetail: {
        content_header_title: 'Geçiş Detayı',
        content_header_description:
            'Geçiş detaylarını buradan görüntüleyebilirsin',
        detail_section_title: 'İşlem Detayları',
        detail_status: 'Durum',
        detail_company_name: 'Şirket Adı',
        detail_branch_name: 'Şube Adı',
        detail_device_name: 'Geçiş Noktası',
        detail_created_at: 'Geçiş Tarihi',
        detail_time_slot: 'Zaman Dilimi',
        detail_entry_rule: 'Geçiş Kuralı',
    },
    AccountActivities: {
        content_header_title: 'Hesap Hareketleri',
        content_header_description:
            'Tüm hesap hareketlerine buradan kolayca ulaşabilirsin',
        search_field_placeholder: 'Filtrele',
    },
    AccountActivitiesFilter: {
        content_header_title: 'Hareketleri Filtrele',
        content_header_description:
            'Gerekli filtrelemeleri yap ve sonuçlara kolayca ulaş',
        categories: 'KATEGORİLER',
        filters: 'FİLTRELER',
        date: 'TARİH ARALIĞI',
        started_date: 'Başlangıç Tarihi',
        end_date: 'Bitiş Tarihi',
        submit: 'Sonuçları Göster',
        balance: 'Bakiye',
        refund: 'İade',
        payment_refund: 'Harcama İadesi',
        deposit_refund: 'Yükleme İadesi',
        cash_deposit_refund: 'Nakit Yükleme İadesi',
        capture: 'Bakiye Harcama',
        top_up: 'Bakiye Yükleme',
        date_time_place_holder: 'Örn. 07/07/2023',
    },
    AccountActivityDetail: {
        content_header_title: 'İşlem Detayı',
        content_header_description:
            'Tüm işlem detaylarına buradan kolayca ulaşabilirsin',
        refund_reason: 'İade Nedeni',
        customer_comment: 'Müşteri Açıklaması',
        company_comment: 'İşletme Açıklaması',
        reference_number: 'Talep No',
        refund_button_title: 'İade İste',
        branch_name: 'Şube Adı',
        cashier: 'Kasiyer',
        total_earned_points: 'Toplam Kazanılan Puan',
        point_group: 'Puan Grubu',
        earned_points: 'Kazanılan Puan',
        earned_wallet: 'Kazanılan Cüzdan',
        top_up: 'Bakiye Yükleme',
        capture: 'Bakiye Harcama',
        process_type: 'İşlem Tipi',
        spent_amount: 'Harcama Miktarı',
        payment_point: 'Ödeme Noktası',
        order_id: 'Sipariş Numarası',
        date: 'Tarih',
        discount_amount: 'İndirim Tutarı',
        amount_after_discount: 'İndirim Sonrası Tutar',
        spent_point: 'Harcanan Puan',
        spent_balance: 'Harcanan Bakiye',
        wallet_type: 'Cüzdan Tipi',
        shared_wallet: 'Paylaşılan Cüzdan',
        sharer: 'Paylaşan Kişi',
        shared: 'Paylaşılan  Kişi',
        expire_date: 'Bitiş Tarihi',
        description: 'Açıklama',
        gift_card: 'Hediye Kartı',
        undefined_user: 'Tanımlanamayan Kullanıcı',
        loaded_amount: 'Yükleme Miktarı',
        bank_amount: 'Karta İade Edilen Miktar',
        invoice_details: 'FATURA BİLGİLERİ',
        invoice_button_text: 'Fatura Görüntüle',
        invoice_no: 'Fatura No',
        invoice_date: 'Fatura Tarihi',
        point_deducted_balance: 'Bakiyeden Düşülen Puan',
        total_revoked_point: 'İptal Edilen Puan',
        reference_code: 'Referans Kod',
        loaded_type: 'Yükleme Tipi',
        cash: 'Nakit Yükleme',
        dcb: 'Faturama Yansıt',
        card_number: 'Kart Numarası',
        payment_refund: 'Harcama İadesi',
        deposit_refund: 'Yükleme İadesi',
        cash_deposit_refund: 'Nakit Yükleme İadesi',
        refunded_amount: 'İade Edilen Tutar',
        refunded_point: 'İade Edilen Puan',
        transaction_details: 'İşlem Bilgileri',
        branch_details: 'Firma Bilgileri',
        additional_details: 'Detay Bilgiler',
        soft_play_details: 'Soft Play Bilgileri',
        bank_transfer: 'Banka Transferi',
        deposit_instruction: 'Yükleme Talimatı',
        payment_refund_history: 'HARCAMA GEÇMİŞİ',
        payment_refund_history_spent_amount: 'Harcama Miktarı',
        purchased_products: 'SATIN ALINAN ÜRÜNLER',
        purchased_products_spent_amount: 'Harcama Miktarı',
        soft_play_child: 'Çocuk',
        soft_play_duration: 'Süre',
        soft_play_price: 'Ücret',
        installment_count: 'Taksit Sayısı',
        total_installment_amount: 'Toplam Taksitli Tutar',
    },
    AccountActivityProductsDetail: {
        content_header_title: 'Satın Alınan Ürünler',
        content_header_description:
            'Tüm işlem detayına buradan kolayca ulaşabilirsin.',
        purchased_products_row_title: 'İŞLEM BİLGİLERİ',
        purchased_products_total_amount_title: 'Toplam',
    },
    GiftCard: {
        route_header_title: 'Hediye Kartı',
        content_header_title: 'Hediye kartı gönderimi nasıl çalışır?',
    },
    GiftCardDetail: {
        section_bar_title: 'Paylaşım Detayı',
        section_bar_description:
            'Tüm işlem detaylarına buradan kolayca ulaşabilirsin',
        cancel_gift_card: 'İptal Et',
        detail_section_title: 'İŞLEM BİLGİLERİ',
        detail_section_name_surname: 'Ad Soyad',
        detail_section_anonymous: 'Bilinmeyen Kişi',
        detail_section_phone_number: 'Telefon Numarası',
        detail_section_deposit: 'Paylaşılan Bakiye',
        detail_section_limitless: 'Limitsiz',
        detail_section_description: 'Açıklama',
        detail_section_expire_date: 'Bitiş Tarihi',
        gift_card_cancel_toast_message: 'Hediye kartın iptal edildi',
        gift_card_cancel_alert_title: 'Hediye Kartı İptali',
        gift_card_cancel_alert_message:
            'Hediye kartını iptal etmek\nistiyor musun?',
        gift_card_cancel_alert_approval_button: 'İptal Et',
        gift_card_cancel_alert_reject_button: 'Vazgeç',
    },
    GiftCardMake: {
        route_header_title: 'Paylaş',
        alert_title: 'İşlem Bilgisi',
        balance_alert_message:
            'Hediye Kartı paylaşımı için belirlediğin toplam tutar, kullanılabilir cüzdan bakiyen üzerinde olamaz',
        balance_alert_top_up_button: 'Bakiye Yükle',
        balance_alert_back_button: 'Yeni Tutar Belirle',
        submit_alert_title: 'Hediye Kartı Gönder',
        submit_alert_message:
            'Gönderilen hediye kartına ait puanlar süresi dolduğunda harcanmazsa hesabına geri yüklenmez',
        submit_alert_approve_button: 'Gönder',
        submit_alert_approve_hidden_button: 'Gönder ve Bir Daha Gösterme',
        submit_alert_reject_button: 'Vazgeç',
        toast_success_message: 'Hediye kartı başarılıyla gönderildi',
        form_wallet_field_section_title: 'Cüzdan Seçimi',
        form_wallet_field_placeholder: 'Cüzdan Seç',
        form_balance_section_title: 'Paylaşılacak Bakiye Tutarı',
        form_date_picker_section_title: 'Son Paylaşım Tarihi',
        form_date_picker_placeholder: 'Tarih Seç',
        form_description_section_title: 'Açıklama',
        form_description_placeholder: 'Örn. İyi ki doğdun',
        form_person_field_section_title: 'Paylaşılacak Kişiler',
        form_person_field_footer: 'Kişi Ekle',
        form_person_field_unknown_user: 'Bilinmeyen Kişi',
        form_submit_button: 'Hediye Kartı Gönder',
        validation_phones_min: 'Paylaşılacak kişi sayısı en az 1 olmalıdır',
        click_to_add_person: 'Kişiyi eklemek için tıkla',
        add_person_description:
            'Hediye Kartı göndermek istediğin kişinin numarasını yaz',
        directory: 'REHBER',
    },
    GiftCardMySent: {
        route_header_title: 'Paylaştıklarım',
        empty_sheet_title: 'Paylaşım Bulunamadı',
        empty_sheet_description: 'Paylaştığın bir hediye kartı bulunamadı',
    },
    GiftCardSentToMe: {
        route_header_title: 'Benimle Paylaşılanlar',
        empty_sheet_title: 'Paylaşım Bulunamadı',
        empty_sheet_description:
            'Seninle paylaşılan bir hediye kartı bulunamadı',
    },
    GiftCardHistoryTabs: {
        route_header_title: 'Paylaşım Geçmişi',
    },
    GiftCardMySentHistory: {
        route_header_title: 'Paylaştıklarım',
        empty_sheet_title: 'Paylaşım Bulunamadı',
        empty_sheet_description: 'Paylaştığın bir hediye kartı bulunamadı',
    },
    GiftCardSentToMeHistory: {
        route_header_title: 'Benimle Paylaşılanlar',
        empty_sheet_title: 'Paylaşım Bulunamadı',
        empty_sheet_description:
            'Seninle paylaşılan bir hediye kartı bulunamadı',
    },
    GiftCardHistoryDetail: {
        section_bar_title: 'Paylaşım Detayı',
        section_bar_description:
            'Tüm işlem detaylarına buradan kolayca ulaşabilirsin',
        detail_section_title: 'İŞLEM BİLGİLERİ',
        detail_section_name_surname: 'Ad Soyad',
        detail_section_anonymous: 'Bilinmeyen Kişi',
        detail_section_phone_number: 'Telefon Numarası',
        detail_section_deposit: 'Paylaşılan Bakiye',
        detail_section_limitless: 'Limitsiz',
        detail_section_description: 'Açıklama',
        detail_section_status: 'Durum',
        detail_section_status_expired: 'Süresi Doldu',
        detail_section_status_cancel: 'İptal Edildi',
        detail_section_status_finished: 'Tamamlandı',
        detail_section_expire_date: 'Bitiş Tarihi',
    },
    GiftCardInfo: {
        info_first_description:
            'Dijital Hediye Kartı ile istediğin cüzdan için sevdiklerine puan gönderimi yapabilirsin. Aynı anda birden fazla kişiye hediye kartı gönderimi yapabilirsin.\nDijital Hediye Kartı gönderimi yapıldığı anda belirlediğin tutar bakiyenden düşecektir.',
        info_second_description:
            'Gönderim yapılan kişi 1 saat içerisinde herhangi bir harcama yapmazsa paylaşımı iptal edebilirsin.\nBelirlemiş olduğun paylaşım süresi sona erdiğinde eğer karşı tarafta puan kaldıysa o puanlar silinecektir ve kalan bakiye senin hesabına geri yüklenecektir.',
        footer_button_continue: 'Devam',
        footer_button_close: 'Kapat',
    },
    Earned: {
        tab_packages: 'Abonelikler/Paketler',
        packages_expired_chip_label: 'Süresi Geçti',
        packages_empty_title: 'Süresi Geçmiş Abonelik/Paket Yok',
        packages_empty_description:
            'Süresi geçmiş bir abonelik veya paket bulunamadı.',
        route_header_title: 'Kazançlarım',
        right_info_title: 'Kazançlarım',
        right_info_description:
            'Kazançlarım sayfasında, şimdiye kadar kazandığınız tüm puanların geçmiş ve güncel detaylarını görüntüleyebilirsiniz. Puan kazanım türü (Kupon, Kampanya, Arkadaşını Davet vb.), son kullanım tarihi ve güncel durumu gibi bilgilere bu ekrandan ulaşabilirsiniz.',
        points_section_title: 'Puanlarım',
        points_section_balance_title: 'Kullanılabilir Puan',
        points_section_amount_title: 'Kazanılan Puan',
        points_section_spent_title: 'Harcanan Puan',
        points_section_scheduled_title: 'Kazanılacak Puan',
        gift_card_title: 'Hediye Kartı',
        empty_sheet_title: 'Kazancın Yok',
        empty_sheet_description:
            'Harcalamarında uygulamayı kullanarak\n daha fazla kazanç elde edebilirsin',
        earned_all: 'Tüm Kazançlarım',
        tab_history: 'Kazanç Geçmişim',
        tab_scheduled: 'Kazanacaklarım',
        scheduled_empty_sheet_title: 'Kazanılacak Puanın Yok',
        scheduled_empty_sheet_description:
            'Henüz planlanmış bir kazancın bulunmuyor',
        scheduled_points_default_title: 'Kazanılacak Puan',
    },
    EarnedPoints: {
        route_header_title: 'Puanlarım',
        list_header_title: 'KAZANÇ GEÇMİŞİM',
    },
    MagneticCards: {
        route_header_title: 'Kartlarım',
        content_header_title: 'Kartlarım',
        content_header_description:
            'Kartlarını hızlı ve güvenli şekilde buradan yönetebilirsin',
        add_button: 'Kart Ekle',
        empty_sheet_title: 'Kart Bulunamadı',
        empty_sheet_description: 'Henüz kayıtlı bir kartın bulunmuyor',
        right_info_title: 'Kartlarım',
        right_info_description:
            'Kartlarım sayfasında manyetik kartlarını görüntüleyebilir, ekleyebilir, düzenleyebilir ve kaldırabilirsin.',
    },
    MagneticCardCreate: {
        route_header_title: 'Kart Ekle',
        content_header_description:
            'Yeni bir kart eklemek için kart numaranı gir',
        form_label_name: 'Kart Adı',
        form_label_code: 'Kart Numarası / Seri Numarası',
        form_placeholder_code: 'Kart numarasını gir',
        spending_limit_row_title: 'Limit Belirle',
        spending_limit_amount_label: 'Harcama Tutarı',
        spending_limit_period_weekly_label: 'Haftalık',
        spending_limit_period_monthly_label: 'Aylık',
        submit_button: 'Kaydet',
        toast_success_message: 'Kart başarıyla eklendi.',
    },
    MagneticCardUpdate: {
        route_header_title: 'Kartı Düzenle',
        route_header_description: 'Kart bilgilerini güncelleyebilirsin',
        form_label_name: 'Kart Adı',
        form_label_code: 'Kart Numarası / Seri Numarası',
        spending_limit_row_title: 'Limit Belirle',
        spending_limit_amount_label: 'Harcama Tutarı',
        spending_limit_period_weekly_label: 'Haftalık',
        spending_limit_period_monthly_label: 'Aylık',
        submit_button: 'Kaydet',
        toast_success_message: 'Kart başarıyla güncellendi.',
        delete_action_label: 'Kartı Sil',
        delete_alert_title: 'Kartı Sil',
        delete_alert_message: 'Kartı silmek istediğine emin misin?',
        delete_alert_approve_button: 'Sil',
        delete_alert_cancel_button: 'Vazgeç',
        delete_toast_message: 'Kart başarıyla kaldırıldı.',
    },
}
